{
    "firebase": {
        "apiKey": "AIzaSyAH49TGtYOjC2IA3L2QwP6BzTpUxkIdczg",
        "authDomain": "testing-flightline.firebaseapp.com",
        "projectId": "testing-flightline",
        "storageBucket": "testing-flightline.firebasestorage.app",
        "messagingSenderId": "601730080387",
        "appId": "1:601730080387:web:fb19d4cf586d164560c5b6"
    },
    "clientName": "Testing Environment",
    "pdfViewerKey": "d4b849d50ed5483c8bf51f2b390223c6",
    "domains": ["testing-flightline.web.app"]
}
